import { DissatisfactionCategories, DissatisfactionCategoriesAPIResponse } from './types';

export function serializeDissatisfactionCategoriesFromAPI(
    json: DissatisfactionCategoriesAPIResponse,
): DissatisfactionCategories {
    if (!json.scores) return [];
    return json.scores.map((score) => format(score.name)) as DissatisfactionCategories;
}

function format(text: string) {
    return text.replaceAll('&', 'and').replaceAll(' ', '_').toLowerCase();
}
